import { defineComponent } from '../Component';

/**
 * Unit identity and base data
 */
export interface UnitDataData {
  unitType: string;
  name: string;
  starLevel: number; // 1-4★
}

export const UnitData = defineComponent<UnitDataData>('unitData');
export type UnitData = InstanceType<typeof UnitData>;

/**
 * Combat stats
 */
export interface StatsData {
  attack: number;
  defense: number;
  speed: number;
  abilityPower: number;
  maxHealth: number;
  currentHealth: number;
  attackRange: number; // in hex distance
  attackSpeed: number; // attacks per second
}

export const Stats = defineComponent<StatsData>('stats');
export type Stats = InstanceType<typeof Stats>;

/**
 * Unit traits for synergy system
 */
export interface TraitsData {
  traitIds: string[];
}

export const Traits = defineComponent<TraitsData>('traits');
export type Traits = InstanceType<typeof Traits>;

/**
 * Ownership and placement state
 */
export interface OwnerData {
  playerId: number; // 1 or 2
  isOnBench: boolean;
  benchSlot: number | null;
}

export const Owner = defineComponent<OwnerData>('owner');
export type Owner = InstanceType<typeof Owner>;

/**
 * Combat state during battle
 */
export interface CombatStateData {
  targetEntityId: string | null;
  attackCooldown: number;
  isMoving: boolean;
  isDead: boolean;
}

export const CombatState = defineComponent<CombatStateData>('combatState');
export type CombatState = InstanceType<typeof CombatState>;

/**
 * Reference to the 3D mesh for this unit
 */
export interface UnitMeshData {
  meshId: string;
}

export const UnitMesh = defineComponent<UnitMeshData>('unitMesh');
export type UnitMesh = InstanceType<typeof UnitMesh>;
